/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pricing_Pack_Get_CreditsInputs */

const en_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get ${i?.count} credits`)
};

const de_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Credits kaufen`)
};

const fr_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtenir ${i?.count} credits`)
};

const es_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtener ${i?.count} creditos`)
};

const it_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ottieni ${i?.count} crediti`)
};

const nl_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koop ${i?.count} credits`)
};

const pl_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kup ${i?.count} kredytow`)
};

const fi_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hanki ${i?.count} krediittiä`)
};

const da_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fa ${i?.count} credits`)
};

const sv_pricing_pack_get_credits = /** @type {(inputs: Pricing_Pack_Get_CreditsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fa ${i?.count} krediter`)
};

/**
* | output |
* | --- |
* | "Get {count} credits" |
*
* @param {Pricing_Pack_Get_CreditsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_pack_get_credits = /** @type {((inputs: Pricing_Pack_Get_CreditsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Pack_Get_CreditsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_pack_get_credits(inputs)
	if (locale === "fr") return fr_pricing_pack_get_credits(inputs)
	if (locale === "es") return es_pricing_pack_get_credits(inputs)
	if (locale === "it") return it_pricing_pack_get_credits(inputs)
	if (locale === "nl") return nl_pricing_pack_get_credits(inputs)
	if (locale === "pl") return pl_pricing_pack_get_credits(inputs)
	if (locale === "fi") return fi_pricing_pack_get_credits(inputs)
	if (locale === "da") return da_pricing_pack_get_credits(inputs)
	if (locale === "sv") return sv_pricing_pack_get_credits(inputs)
	return en_pricing_pack_get_credits(inputs)
});